/**
 * @Description 组件 HomePage 布局
 * @Author 
 * @Date 
 */
/* HTML */
<template>
	<!-- view-home-page start -->
	<div class="view-home-page">
		<!-- app-home-box start -->
		<div class="app-home-box">
			<!-- app-home-view start -->
			<div class="app-home-view" v-resize="elFormResize">
				
				<!-- home-sub-item home-sub-top start -->
				<div class="home-sub-item home-sub-top">
					<!-- sub-item-box start -->
					<div class="sub-item-box">
						<i class="bg-lt"></i>
						<i class="bg-rt"></i>
						<i class="bg-lb"></i>
						<i class="bg-rb"></i>
						<div class="sub-item-box-bg">
							
							<!-- sub-item-content start -->
							<div class="sub-item-content">
								<div class="item-content-box top-item-box">
									
									<!-- item-title-box start-->
									<div class="item-title-box">
										<span>人员状态</span>
										<el-button type="primary" size="mini" class="linear-bg" @click.native="gotoStatusDetail('user')" style="float: right;">&ensp;详情&ensp;&gt;&gt;</el-button>
									</div>
									<!-- item-title-box end-->
									
									<!-- main-content-box start -->
									<div class="main-content-box">
										<!-- 暂无数据 start -->
										<div v-if="false" class="flex-center" style="color: #fff;font-size: 30px;height: 100%;width: 100%;">暂无数据</div>
										<!-- chart -->
										<div v-show="true" ref="chart_users" class="main-content-wrap"></div>
									</div>
									<!-- main-content-box end -->
									
								</div>
							</div>
							<!-- sub-item-content end -->
							
							<!-- sub-item-content start -->
							<div class="sub-item-content">
								<div class="item-content-box top-item-box">
									
									<!-- item-title-box start-->
									<div class="item-title-box">
										<span>车辆状态</span>
										<el-button type="primary" size="mini" class="linear-bg" @click.native="gotoStatusDetail('car')" style="float: right;">&ensp;详情&ensp;&gt;&gt;</el-button>
									</div>
									<!-- item-title-box end-->
									
									<!-- main-content-box start -->
									<div class="main-content-box">
										<!-- 暂无数据 start -->
										<div v-if="false" class="flex-center" style="color: #fff;font-size: 30px;height: 100%;width: 100%;">暂无数据</div>
										<!-- chart -->
										<div v-show="true" ref="chart_cars" class="main-content-wrap"></div>
									</div>
									<!-- main-content-box end -->
									
								</div>
							</div>
							<!-- sub-item-content end -->
							
							<!-- sub-item-content start -->
							<div class="sub-item-content">
								<div class="item-content-box top-item-box">
									
									<!-- item-title-box start-->
									<div class="item-title-box">
										<span>设备状态</span>
										<el-button type="primary" size="mini" class="linear-bg" @click.native="gotoStatusDetail('device')" style="float: right;">&ensp;详情&ensp;&gt;&gt;</el-button>
									</div>
									<!-- item-title-box end-->
									
									<!-- main-content-box start -->
									<div class="main-content-box">
										<!-- 暂无数据 start -->
										<div v-if="false" class="flex-center" style="color: #fff;font-size: 30px;height: 100%;width: 100%;">暂无数据</div>
										<!-- chart -->
										<div v-show="true" ref="chart_devices" class="main-content-wrap"></div>
									</div>
									<!-- main-content-box end -->
									
								</div>
							</div>
							<!-- sub-item-content end -->
							
							<!-- sub-item-content start -->
							<div class="sub-item-content">
								<div class="item-content-box top-item-box">
									
									<!-- item-title-box start-->
									<div class="item-title-box">
										<span>流量卡状态</span>
										<el-button type="primary" size="mini" class="linear-bg" @click.native="gotoStatusDetail('sim')" style="float: right;">&ensp;详情&ensp;&gt;&gt;</el-button>
									</div>
									<!-- item-title-box end-->
									
									<!-- main-content-box start -->
									<div class="main-content-box">
										<!-- 暂无数据 start -->
										<div v-if="false" class="flex-center" style="color: #fff;font-size: 30px;height: 100%;width: 100%;">暂无数据</div>
										<!-- chart -->
										<div v-show="true" ref="chart_sims" class="main-content-wrap"></div>
									</div>
									<!-- main-content-box end -->
									
								</div>
							</div>
							<!-- sub-item-content end -->
							
						</div>
					</div>
					<!-- sub-item-box end -->
				</div>
				<!-- home-sub-item home-sub-top end -->
				
				<!-- home-sub-item home-sub-bottom start -->
				<div class="home-sub-item home-sub-bottom">
					<!-- sub-bottom-item start -->
					<div class="sub-bottom-item">
						<!-- sub-item-box start -->
						<div class="sub-item-box">
							<i class="bg-lt"></i>
							<i class="bg-rt"></i>
							<i class="bg-lb"></i>
							<i class="bg-rb"></i>
							<div class="sub-item-box-bg">
								
								<!-- sub-item-content start -->
								<div class="sub-item-content">
									<div class="item-content-box">
										
										<!-- item-title-box start-->
										<div class="item-title-box" style="padding: 10px 10px 0;">
											<span>告警状态</span>
											<el-button type="primary" size="mini" class="linear-bg" @click.native="gotoStatusDetail('alarm')" style="float: right;">&ensp;详情&ensp;&gt;&gt;</el-button>
										</div>
										<!-- item-title-box end-->
										
										<!-- main-content-box start -->
										<div class="main-content-box">
											<!-- 暂无数据 start -->
											<div v-if="false" class="flex-center" style="color: #fff;font-size: 30px;height: 100%;width: 100%;">暂无数据</div>
											<!-- chart -->
											<div v-show="true" ref="chart_alarm" class="main-content-wrap"></div>
										</div>
										<!-- main-content-box end -->
										
									</div>
								</div>
								<!-- sub-item-content end -->
								
							</div>
						</div>
						<!-- sub-item-box end -->
					</div>
					<!-- sub-bottom-item end -->
					
					<!-- sub-bottom-item start -->
					<div class="sub-bottom-item">
						<!-- sub-item-box start -->
						<div class="sub-item-box ">
							<i class="bg-lt"></i>
							<i class="bg-rt"></i>
							<i class="bg-lb"></i>
							<i class="bg-rb"></i>
							<div class="sub-item-box-bg">
								
								<!-- sub-item-content start -->
								<div class="sub-item-content">
									<div class="item-content-box">
										
										<!-- item-title-box start-->
										<div class="item-title-box" style="padding: 10px 10px 0;">
											<span>设备分布</span>
											<el-button type="primary" size="mini" class="linear-bg" @click.native="gotoStatusDetail('realPosition')" style="float: right;">&ensp;详情&ensp;&gt;&gt;</el-button>
										</div>
										<!-- item-title-box end-->
										
										<!-- main-content-box start -->
										<div class="main-content-box" style="overflow: hidden;">
											<!-- 组件 设备分布 -->
											<DeviceDistribution />
										</div>
										<!-- main-content-box end -->
										
									</div>
								</div>
								<!-- sub-item-content end -->
								
							</div>
						</div>
						<!-- sub-item-box end -->
					</div>
					<!-- sub-bottom-item end -->
				</div>
				<!-- home-sub-item home-sub-bottom end -->
				
			</div>
			<!-- app-home-view end -->
		</div>
        <!-- app-home-box ens -->
        
        <!-- 告警状态 -->
        <AlarmStatusDialog ref="AlarmStatusDialog" />
        
	</div>
	<!-- view-home-page end -->
</template>

/* JS */
<script>
	// API 首页数据
	import ApiHome from '@/request/api-home';
	// 组件 告警状态
	import AlarmStatusDialog from '@/components_outdoor/Home/AlarmStatusDialog';
	// 组件 设备分布
	import DeviceDistribution from './DeviceDistribution';
	
	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
        name: "HomePage",
        
        /**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
        components: {
        	// 组件 告警状态
        	AlarmStatusDialog,
        	// 组件 设备分布
        	DeviceDistribution,
        },// components
        
        /**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
        props: {
        	
        },// props
        
        /**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				// 整体数据
				alarmStatus: [
					{alarmNameEn: "SOS", alarm: 1,count: 0,alarmName: "紧急求助"},
					{alarmNameEn: "Battery low alarm", alarm: 7, count: 0, alarmName : "低电量报警"}
				],// 报警状态
				carStatus: {onlineNum: 0, offlineNum: 0},// 车辆状态
				deviceStatus: {onlineNum: 0, offlineNum: 0},// 设备状态
				simStatus: {currentMonthLastTime: 1764518399999, expiredNum: 0, currentMonthExpireNum: 0},// 流量卡状态
				userStatus: {onlineNum: 0, offlineNum: 0},// 人员状态
				
				// 当月最后一天的23:59:59
				currentMonthLastTime: null,
				
				// chart 图表
				myChart_users: null,// chart 人员 状态
				myChart_cars: null,// chart 车辆 状态
				myChart_devices: null,// chart 设备 状态
				myChart_sims: null,// chart 流量卡 状态
				myChart_alarm: null,// chart 告警 状态
				
				// 交互锁
				lock: false,
				
				// timer
				timer_search_data: null,// 查询 数据
			}// return
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			// 当月最后一天的23:59:59
			let data_last = this.$GlobalFun.getLastDayOfCurrentMonth();
			this.currentMonthLastTime = data_last.getTime();
			this.simStatus.currentMonthLastTime = this.currentMonthLastTime;
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			// 查询 首页数据
			this.searchHomeData();
		},// mounted
		
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			// 交互锁
			this.lock = false;
			
			// 清除计时器
			this.clearTimers();
			
			// 销毁 charts
			this.disposeCharts();
		},// beforeDestroy
		
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {
			
		},// destroyed
		
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			/**
			 * @Des 清除计时器
			 * @Auth
			 * @Date 
			 */
			clearTimers() {
				// timer 清除
				if (!this.$checkEmpty(this.timer_search_data)) {
					clearTimeout(this.timer_search_data);
					this.timer_search_data = null;
				}
			},// clearTimers
			/**
			 * @Des dom 尺寸更改
			 * @Auth
			 * @Date 
			 */
			elFormResize(data) {
				// 延迟执行
				this.$nextTick(() => {
					// 重绘 charts
					this.resizeCharts();
				});
			},// elFormResize
			/**
			 * @Des 详情
			 * @Auth
			 * @Date 
			 */
			gotoStatusDetail(subkey) {
				if (subkey == 'user') {
					// 人员状态
					this.$router.push({name: 'gps', params: {bindType: '1', tab: 'device'}});
				} else if (subkey == 'car') {
					// 车辆状态
					this.$router.push({name: 'gps', params: {bindType: '2', tab: 'device'}});
				} else if (subkey == 'device') {
					// 设备状态
					this.$router.push({name: 'gps', params: {bindType: '', tab: 'device'}});
				} else if (subkey == 'sim') {
					// 流量卡状态
					this.$router.push({name: 'gps', params: {currentMonthLastTime: this.simStatus.currentMonthLastTime, tab: 'sim'}});
				} else if (subkey == 'alarm') {
					// 告警状态
					
					// 弹出 告警状态
					this.$refs.AlarmStatusDialog.openDialog('告警状态');
				} else if (subkey == 'realPosition') {
					// 设备分布
					// this.$router.push({name: 'position-real', params: {did: did, uploadTime: uploadTime, tab: 'track'}});
					this.$router.push({name: 'position-real', params: {}});
				}
			},// gotoStatusDetail
			
			/**
			 * @Des 查询 首页数据
			 * @Auth
			 * @Date 
			 */
			searchHomeData() {
				// 交互锁
				if (this.lock) return false;
				
				// timer 清除
				if (!this.$checkEmpty(this.timer_search_data)) {
					clearTimeout(this.timer_search_data);
					this.timer_search_data = null;
				}
				
				// 交互锁
				this.lock = true;
				this.$request.postJsonRequest(ApiHome.homeIndexApi, {
					
				}).then(result => {
					// 交互锁
					this.lock = false;
					// console.log('searchHomeData', result);
					
					if (result.code == 0) {
						let data = Object.assign({}, result.data);
						// 整体数据
						this.alarmStatus = Object.assign([], data.alarmStatus);// 报警状态
						this.carStatus = Object.assign({}, data.carStatus);// 车辆状态
						this.deviceStatus = Object.assign({}, data.deviceStatus);// 设备状态
						this.simStatus = Object.assign({}, data.simStatus);// 流量卡状态
						this.userStatus = Object.assign({}, data.userStatus);// 人员状态
					} else {
						// 整体数据
						this.alarmStatus = [
							{alarmNameEn: "SOS", alarm: 1,count: 0,alarmName: "紧急求助"},
							{alarmNameEn: "Battery low alarm", alarm: 7, count: 0, alarmName : "低电量报警"}
						];// 报警状态
						this.carStatus = {onlineNum: 0, offlineNum: 0};// 车辆状态
						this.deviceStatus = {onlineNum: 0, offlineNum: 0};// 设备状态
						this.simStatus = {currentMonthLastTime: currentMonthLastTime, expiredNum: 0, currentMonthExpireNum: 0};// 流量卡状态
						this.userStatus = {onlineNum: 0, offlineNum: 0};// 人员状态
						
						// 获取失败，提示错误信息
						this.$message({
							message: result.msg,
							type: 'error',
							showClose: true,
							dangerouslyUseHTMLString: true
						});
					}
					
					// 初始化 charts
					this.initCharts();
					
					// timer 查询数据
					this.timer_search_data = setTimeout(() => {
						// timer 清除
						if (!this.$checkEmpty(this.timer_search_data)) {
							clearTimeout(this.timer_search_data);
							this.timer_search_data = null;
						}
						// 查询 首页数据
						this.searchHomeData();
					}, 30 * 1000);
				}).catch(error => {
					// 交互锁
					this.lock = false;
					console.error('查询首页数据异常', ApiHome.homeIndexApi, error);
					// 初始化 charts
					this.initCharts();
					
					// timer 清除
					if (!this.$checkEmpty(this.timer_search_data)) {
						clearTimeout(this.timer_search_data);
						this.timer_search_data = null;
					}
					// timer 查询数据
					this.timer_search_data = setTimeout(() => {
						// timer 清除
						if (!this.$checkEmpty(this.timer_search_data)) {
							clearTimeout(this.timer_search_data);
							this.timer_search_data = null;
						}
						// 查询 首页数据
						this.searchHomeData();
					}, 30 * 1000);
				})
			},
			
			/**
			 * @Des 销毁 charts
			 * @Auth
			 * @Date 
			 */
			disposeCharts() {
				// dispose
				if (this.myChart_users) {
					this.myChart_users.dispose();
					this.myChart_users = null;
				}
				// dispose
				if (this.myChart_cars) {
					this.myChart_cars.dispose();
					this.myChart_cars = null;
				}
				// dispose
				if (this.myChart_devices) {
					this.myChart_devices.dispose();
					this.myChart_devices = null;
				}
				// dispose
				if (this.myChart_sims) {
					this.myChart_sims.dispose();
					this.myChart_sims = null;
				}
				// dispose
				if (this.myChart_alarm) {
					this.myChart_alarm.dispose();
					this.myChart_alarm = null;
				}
			},// disposeCharts
			/**
			 * @Des 初始化 charts
			 * @Auth
			 * @Date 
			 */
			initCharts() {
				// 销毁 charts
				this.disposeCharts();
				
				// myChart 人员 状态
				this.myChart_users = this.$echarts.init(this.$refs['chart_users']);
				// 初始化 chart 人员 状态
				this.initChart_users();
				
				// myChart 车辆 状态
				this.myChart_cars = this.$echarts.init(this.$refs['chart_cars']);
				// 初始化 chart 车辆 状态
				this.initChart_cars();
				
				// myChart 设备 状态
				this.myChart_devices = this.$echarts.init(this.$refs['chart_devices']);
				// 初始化 chart 设备 状态
				this.initChart_devices();
				
				// myChart 流量卡 状态
				this.myChart_sims = this.$echarts.init(this.$refs['chart_sims']);
				// 初始化 chart 流量卡 状态
				this.initChart_sims();
				
				// myChart 告警 状态
				this.myChart_alarm = this.$echarts.init(this.$refs['chart_alarm']);
				// 初始化 chart 告警 状态
				this.initChart_alarm();
				
			},// initCharts
			
			/**
			 * @Des 重绘 charts
			 * @Auth
			 * @Date 
			 */
			resizeCharts() {
				// 初始化 charts
				this.initCharts();
				return false;
				
				// myChart 人员 状态
				this.myChart_users && this.myChart_users.resize();
				
				// myChart 车辆 状态
				this.myChart_cars && this.myChart_cars.resize();
				
				// myChart 设备 状态
				this.myChart_devices && this.myChart_devices.resize();
				
				// myChart 流量卡 状态
				this.myChart_sims && this.myChart_sims.resize();
				
				// myChart 告警 状态
				this.myChart_alarm && this.myChart_alarm.resize();
				
			},// resizeCharts
			
			/**
			 * @Des 初始化 chart 饼图 人员 状态
			 * @Auth
			 * @Date 
			 */
			initChart_users() {
				
				// 数据重组
				let dataList = Object.assign([], []);
				
				// 提取数据
				dataList.push({name: '在线人数', value: this.userStatus.onlineNum || 0});// 在线人数
				dataList.push({name: '离线人数', value: this.userStatus.offlineNum || 0});// 离线人数
				
				let THIS = this;
				this.option_users = {
					darkMode: false,
					textStyle: {
						/*color: '#B9B8CE'*/
						color: '#fff'
					},
					title: {
						text: '',
						subtext: '',
						left: 'center',
						textStyle: {
							color: '#fff',
							fontSize: 18,
							fontWeight: 'bold'
						},
						subtextStyle: {
							color: '#fff',
							fontSize: 12
						}
					},
					tooltip: {
						trigger: 'item',
						textStyle: {
							align: 'justify'
						}
					},
					legend: {
						orient: 'vertical',
						left: 'left',
						top: 'bottom',
						textStyle: {
							color: '#fff',
							lineHeight: 0,
							height: 0,
							rich:{
		                        a:{
		                            fontSize:14,
		                            align:'left',
		                            padding:[0,0,0,0],
		                            verticalAlign: 'middle',
		                        },
		                        b:{
		                            fontSize:18,
		                        	lineHeight: 0,
		                            align:'center',
		                            padding:[0,0,0,0],
		                            fontWeight: 'bold'
		                        }
							}
						},
						icon:'circle',
						formatter: function (name) {
							let data = THIS.option_users.series[0].data;
							// console.log(data, 'data')
							let total = 0;
							let tarValue;
							for (let i = 0; i < data.length; i++) {
								let _value = data[i].value;
								total += _value;
								
								if (data[i].name == name) {
									tarValue = _value;
								}
							};
							let v = tarValue;// + '人';
							//计算出百分比
							let p = Math.round((tarValue / total) * 100) + '%';
							
							return  '{a|'+ name +' } {b|'+ v +'}';
							//return `${name}  \n ${'<b>'+v+'</b>'}`;
							//name是名称，v是数值
						},
					},
					color: ['#05c091', '#ffcc43', '#ff4343', '#4375ff', '#4185f0', '#feb10d', '#08d5fb', '#58d9f9', '#4992ff', '#7cffb2', '#ff8a45', '#8d48e3', '#fddd60', '#dd79ff', '#ff6e76', ],
					series: [
						{
							name: '人员状态',
							type: 'pie',
							radius: '60%',
							// radius: ['50%', '60%'],
							
							center: ['55%', '40%'],
							
							data: dataList,
							emphasis: {
								itemStyle: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.8)'
								}
							},
							label: {
								show: false
							},
							labelLine: {
								show: false
							}
						}
					]
				};
				// set option
				this.myChart_users.setOption(this.option_users);
			},// initChart_users
			
			/**
			 * @Des 初始化 chart 饼图 车辆 状态
			 * @Auth
			 * @Date 
			 */
			initChart_cars() {
				
				// 数据重组
				let dataList = Object.assign([], []);
				
				// 提取数据
				dataList.push({name: '在线车辆', value: this.carStatus.onlineNum || 0});// 在线车辆
				dataList.push({name: '离线车辆', value: this.carStatus.offlineNum || 0});// 离线车辆
				
				let THIS = this;
				this.option_cars = {
					darkMode: false,
					textStyle: {
						/*color: '#B9B8CE'*/
						color: '#fff'
					},
					title: {
						text: '',
						subtext: '',
						left: 'center',
						textStyle: {
							color: '#fff',
							fontSize: 18,
							fontWeight: 'bold'
						},
						subtextStyle: {
							color: '#fff',
							fontSize: 12
						}
					},
					tooltip: {
						trigger: 'item',
						textStyle: {
							align: 'justify'
						}
					},
					legend: {
						//orient: 'vertical',
						left: 'center',
						top: 'bottom',
						textStyle: {
							color: '#fff',
							lineHeight: 0,
							height: 0,
							rich:{
		                        a:{
		                            fontSize:14,
		                            align:'left',
		                            padding:[0,0,0,0],
		                            verticalAlign: 'middle'
		                        },
		                        b:{
		                            fontSize:18,
		                        	lineHeight: 0,
		                        	
		                            align:'center',
		                            padding:[0,0,0,0],
		                            fontWeight: 'bold'
		                        }
							}
						},
						icon:'circle',
						formatter: function (name) {
							let data = THIS.option_cars.series[0].data;
							// console.log(data, 'data')
							let total = 0;
							let tarValue;
							for (let i = 0; i < data.length; i++) {
								let _value = data[i].value;
								total += _value;
								
								if (data[i].name == name) {
									tarValue = _value;
								}
							};
							let v = tarValue;// + '人';
							//计算出百分比
							let p = Math.round((tarValue / total) * 100) + '%';
							
							return  '{a|'+ name +' } {b|'+ v +'}';
							//return `${name}  \n ${'<b>'+v+'</b>'}`;
							//name是名称，v是数值
						},
					},
					color: ['#4992ff', '#ff6e76', '#7cffb2', '#feb10d', '#ff4343', '#ffcc43', '#4375ff', '#4185f0', '#08d5fb', '#05c091', '#58d9f9', '#ff8a45', '#8d48e3', '#fddd60', '#dd79ff', ],
					series: [
						{
							name: '车辆状态',
							type: 'pie',
							//radius: '60%',
							// radius: ['50%', '60%'],
							
							radius: ['30%', '60%'],
							avoidLabelOverlap: false,
							itemStyle: {
								borderRadius: 5,
								borderColor: '#051745',
								borderWidth: 8
							},
							
							center: ['50%', '40%'],
							
							data: dataList,
							emphasis: {
								itemStyle: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.8)'
								}
							},
							label: {
								show: false
							},
							labelLine: {
								show: false
							}
						}
					]
				};
				// set option
				this.myChart_cars.setOption(this.option_cars);
			},// initChart_cars
			
			/**
			 * @Des 初始化 chart 饼图 设备 状态
			 * @Auth
			 * @Date 
			 */
			initChart_devices() {
				
				// 数据重组
				let dataList = Object.assign([], []);
				
				// 提取数据
				dataList.push({name: '在线设备', value: this.deviceStatus.onlineNum || 0});// 在线设备
				dataList.push({name: '离线设备', value: this.deviceStatus.offlineNum || 0});// 离线设备
				
				let THIS = this;
				this.option_devices = {
					darkMode: false,
					textStyle: {
						/*color: '#B9B8CE'*/
						color: '#fff'
					},
					title: {
						text: '',
						subtext: '',
						left: 'center',
						textStyle: {
							color: '#fff',
							fontSize: 18,
							fontWeight: 'bold'
						},
						subtextStyle: {
							color: '#fff',
							fontSize: 12
						}
					},
					tooltip: {
						trigger: 'item',
						textStyle: {
							align: 'justify'
						}
					},
					legend: {
						orient: 'vertical',
						left: 'right',
						top: 'bottom',
						textStyle: {
							color: '#fff',
							lineHeight: 0,
							height: 0,
							rich:{
		                        a:{
		                            fontSize:14,
		                            align:'left',
		                            padding:[0,0,0,0],
		                            verticalAlign: 'middle'
		                        },
		                        b:{
		                            fontSize:18,
		                        	lineHeight: 0,
		                        	
		                            align:'center',
		                            padding:[0,0,0,0],
		                            fontWeight: 'bold'
		                        }
							}
						},
						icon:'circle',
						formatter: function (name) {
							let data = THIS.option_devices.series[0].data;
							// console.log(data, 'data')
							let total = 0;
							let tarValue;
							for (let i = 0; i < data.length; i++) {
								let _value = data[i].value;
								total += _value;
								
								if (data[i].name == name) {
									tarValue = _value;
								}
							};
							let v = tarValue;// + '人';
							//计算出百分比
							let p = Math.round((tarValue / total) * 100) + '%';
							
							return  '{a|'+ name +' } {b|'+ v +'}';
							//return `${name}  \n ${'<b>'+v+'</b>'}`;
							//name是名称，v是数值
						},
					},
					color: ['#00f6fb', '#ff4343', '#4992ff', '#ffcc43', '#4375ff', '#4185f0', '#feb10d', '#08d5fb', '#05c091', '#58d9f9', '#7cffb2', '#ff8a45', '#8d48e3', '#fddd60', '#dd79ff', '#ff6e76', ],
					series: [
						{
							name: '设备状态',
							type: 'pie',
							// radius: '60%',
							// radius: ['50%', '60%'],
							
							radius: ['20%', '60%'],
							avoidLabelOverlap: false,
							itemStyle: {
								borderRadius: 5,
								borderColor: '#fff',
								borderWidth: 5
							},
							
							center: ['45%', '40%'],
							
							data: dataList,
							emphasis: {
								itemStyle: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.8)'
								}
							},
							label: {
								show: false
							},
							labelLine: {
								show: false
							}
						}
					]
				};
				// set option
				this.myChart_devices.setOption(this.option_devices);
			},// initChart_devices
			
			/**
			 * @Des 初始化 chart 柱状图 SIM
			 * @Auth
			 * @Date 
			 */
			initChart_sims() {
				// 提取数据
				let nameList = ['已过期', '即将过期'];
				let numList = [(this.simStatus.expiredNum || 0), (this.simStatus.currentMonthExpireNum || 0)];
				
				this.option_sims = {
					darkMode: true,
					textStyle: {
						color: '#fff'
					},
					title: {
						text: '',
						subtext: '',
						textStyle: {
							color: '#B9B8CE',
							fontSize: 18,
							fontWeight: 'bold'
						},
						subtextStyle: {
							color: '#B9B8CE',
							fontSize: 12
						},
						left: 'center',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						},
						textStyle: {
							align: 'justify'
						}
					},
					legend: {
						show: false,
						left: 'right',
						textStyle: {
							color: '#B9B8CE'
						}
					},
					grid: {
						top: '10%',
						left: '0%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					yAxis: {
						show: false,
						type: 'value',
						boundaryGap: [0, 0.01],
						minInterval: 1,
						axisLine: {
							show: true
						},
						axisTick: {
							show: true
						}
					},
					xAxis: {
						type: 'category',
						axisLabel: {
							interval:0, //强制显示文字
						},
						data: nameList
					},
					series: [
						{
							name: '数量',
							type: 'bar',
							label: {
								show: true,
								formatter: '{c}',
								color: '#fff',
								fontSize: 16,
								position: 'top', //在上方显示
							},
							itemStyle: {
								color: function (param) {
									let colorList = [
										'#ff6e76', '#feb10d', '#808080', '#ffcc43', '#008001', '#51dd0f', '#6fdb3b', '#60c230',
										'#98e274', '#8acc6a', '#74ac59', '#55e50f', '#4ac90c', '#42b10c',
									];
									return colorList[param.dataIndex] || 'red';
								}
							},
							data: numList
						}
					]
				};
				
				// set option
				this.myChart_sims.setOption(this.option_sims);
			},// initChart_sims
			
			/**
			 * @Des 初始化 chart 柱状图 告警
			 * @Auth
			 * @Date 
			 */
			initChart_alarm() {
				let alarmStatus = Object.assign([], this.alarmStatus);
				
				// 提取数据
				let nameList = [];
				let numList = [];
				alarmStatus.forEach((row, index) => {
					// 空值  跳过
					if (this.$checkEmpty(row)) return true;
					nameList.push(row.alarmName);
					numList.push(row.count);
				});
				
				this.option_alarm = {
					// darkMode: true,
					textStyle: {
						color: '#fff'
					},
					title: {
						text: '',
						subtext: '',
						textStyle: {
							color: '#B9B8CE',
							fontSize: 18,
							fontWeight: 'bold'
						},
						subtextStyle: {
							color: '#B9B8CE',
							fontSize: 12
						},
						left: 'center',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						},
						textStyle: {
							align: 'justify'
						}
					},
					legend: {
						show: false,
						left: 'right',
						textStyle: {
							color: '#B9B8CE'
						}
					},
					grid: {
						top: '10%',
						left: '0%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: {
						show: true,
						type: 'value',
						boundaryGap: [0, 0.01],
						minInterval: 1,
						axisLine: {
							show: true,
							lineStyle: {
						        color: '#fff', // 绿色
						        width: 2, // 宽度为2px
						        type: 'solid' // 实线类型
						    }
						},
						axisTick: {
							show: true,
						},
						// 网格线样式
						splitLine: {
							show: true, // 控制网格线是否显示
							lineStyle: {
								color: ['#666'] // 设置网格线颜色
							}
						}
					},
					yAxis: {
						type: 'category',
						axisLabel: {
							interval: 0, //强制显示文字
						},
						axisLine: {
							show: true,
							lineStyle: {
						        color: '#fff', // 绿色
						        width: 2, // 宽度为2px
						        type: 'solid' // 实线类型
						    }
						},
						data: nameList
					},
					series: [
						{
							name: '数量',
							type: 'bar',
							label: {
								show: true,
								formatter: '{c}',
								color: '#fff',
								fontSize: 16,
								position: 'right', //在上方显示
							},
							itemStyle: {
								color: function (param) {
									let colorList = [
										
										'#fa628b', '#fc9b4e', '#5070dd', '#505372', '#808080', '#51dd0f',
										'#98e274', '#8acc6a', '#74ac59', '#55e50f', '#4ac90c', '#42b10c',
									];
									return colorList[param.dataIndex] || 'red';
								}
							},
							data: numList
						}
					]
				};
				
				// set option
				this.myChart_alarm.setOption(this.option_alarm);
			},// initChart_alarm
			
		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
    }// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>


// WEBPACK FOOTER //
// src/components_outdoor/Home/HomePage.vue